"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = require("react-helmet");
var _tokens = require("../tokens");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
const fontImportFunc = function () {
  let assetFolder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  return `
  @font-face {
    font-family: 'Adjusted Georgia Fallback';
    src: local(Georgia);
    size-adjust: 112%;
    ascent-override: normal;
    descent-override: normal;
    line-gap-override: normal;
  }

  @font-face {
    font-family: 'Visuelt';
    font-weight: ${_tokens.FONT.WEIGHT.REGULAR};
    font-style: normal;
    src: local('Visuelt'),
      url(${assetFolder}visuelt-regular.woff2) format('woff2'),
      url(${assetFolder}visuelt-regular.woff) format('woff'),
      url(${assetFolder}visuelt-regular.ttf) format('truetype'),
      url(${assetFolder}visuelt-regular.eot?#iefix) format('embedded-opentype');
    unicode-range: U+000-5FF;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Visuelt';
    font-weight: ${_tokens.FONT.WEIGHT.MEDIUM};
    font-style: normal;
    src: local('Viseult'),
      url(${assetFolder}visuelt-medium.woff2) format('woff2'),
      url(${assetFolder}visuelt-medium.woff) format('woff'),
      url(${assetFolder}visuelt-medium.ttf) format('truetype'),
      url(${assetFolder}visuelt-medium.eot?#iefix) format('embedded-opentype');
    unicode-range: U+000-5FF;
    font-display: fallback;
  }

  @font-face {
    font-family: 'Visuelt';
    font-weight: ${_tokens.FONT.WEIGHT.BOLD};
    font-style: normal;
    src: local('Viseult'),
      url(${assetFolder}visuelt-bold.woff2) format('woff2'),
      url(${assetFolder}visuelt-bold.woff) format('woff'),
      url(${assetFolder}visuelt-bold.ttf) format('truetype'),
      url(${assetFolder}visuelt-bold.eot?#iefix) format('embedded-opentype');
    unicode-range: U+000-5FF;
    font-display: fallback;
  }
`.replace(/\n/g, ' ').replace(/ +/g, ' ');
};
const FontStylesheet = _ref => {
  let {
    assetFolder
  } = _ref;
  const fontImports = fontImportFunc(assetFolder);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("link", {
    rel: "preconnect",
    href: "https://fonts.googleapis.com"
  }), /*#__PURE__*/_react.default.createElement("link", {
    rel: "preconnect",
    href: "https://fonts.gstatic.com",
    crossOrigin: ""
  }), /*#__PURE__*/_react.default.createElement("link", {
    href: "https://fonts.googleapis.com/css2?family=Arbutus+Slab&display=swap",
    rel: "stylesheet"
  }), /*#__PURE__*/_react.default.createElement("style", {
    type: "text/css"
  }, fontImports)));
};
FontStylesheet.propTypes = {
  assetFolder: _propTypes.default.string
};
FontStylesheet.defaultProps = {
  assetFolder: '/'
};
var _default = exports.default = FontStylesheet;